import script from "./managerHome.vue?vue&type=script&lang=ts&setup=true"
export * from "./managerHome.vue?vue&type=script&lang=ts&setup=true"

import "./managerHome.vue?vue&type=style&index=0&id=296de3c0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296de3c0"]])

export default __exports__